import { TemplateData, TemplateParams } from '.';

const calendarEventParticipation = ({
  defaultPlaceholders,
  messages
}: TemplateParams): TemplateData => ({
  category: 'calendar-events',
  email: {
    buttonEnabled: true,
    buttonLink: '{{siteUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.completionEmailUserContent1CalendarEvent}
        ${messages.completionEmailUserContent2CalendarEvent}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    heading: messages.completionEmailUserHeading,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    subject: `{{siteName}}: {{eventTitle}} ${messages.completionEmailSubject}`
  },
  placeholders: {
    eventTime: {
      label: messages.calendarEventDateAndTime,
      example: '27.3.2024 08:00 - 10:00'
    },
    eventTitle: {
      label: messages.calendarEventTitle,
      example: 'Test event'
    },
    ...defaultPlaceholders
  },
  title: messages.calendarEventParticipation
});

export default calendarEventParticipation;
